import React from 'react';
import { Facebook, Instagram, LinkedinIcon as Linkedin, Mail, MapPin as MapPinIcon, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';

const bgImage = '/assets/footer.jpg';

const Footerlanding = () => {
  const navigate = useNavigate();
  const { token, userType, user } = useAuthStore();

  return (
    <div className="">
      <footer className="relative bg-gray-900 text-gray-400">
        {/* Background image and overlay */}
        <div
          className="absolute inset-0 w-full h-full z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center ",
            backgroundRepeat: "no-repeat",
            objectFit: "cover"
          }}
          aria-hidden="true"
        />
        {/* Restore overlay opacity for stronger shadow */}
        <div className="absolute inset-0 w-full h-full bg-black bg-opacity-80 z-10" aria-hidden="true" />

        {/* Content wrapper with reduced vertical padding */}
        <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 py-4">
          {/* Top Section: For Professionals */}
          <div className="flex flex-col items-center justify-center mb-6">
            <h2 className="text-lg sm:text-xl font-semibold text-white mb-2 text-center">For Professionals</h2>
            <div className="flex flex-col sm:flex-row gap-3 w-full max-w-sm justify-center">
              {token && user && (
                <div className="flex flex-col sm:flex-row gap-3 w-full justify-center">
                  {userType === "builder" && (
                    <button
                      onClick={() => { window.scrollTo(0, 0); navigate('/builder/profile'); }}
                      className="flex-1 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm whitespace-nowrap flex items-center justify-center gap-2"
                    >
                      <User className="w-4 h-4" />
                      Hello, {user.name?.split(" ")[0] || "Builder"}
                    </button>
                  )}
                  {userType === "agent" && (
                    <button
                      onClick={() => { window.scrollTo(0, 0); navigate('/agent/profile'); }}
                      className="flex-1 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm whitespace-nowrap flex items-center justify-center gap-2"
                    >
                      <User className="w-4 h-4" />
                      Hello, {user.name?.split(" ")[0] || "Agent"}
                    </button>
                  )}
                  {userType === "consultant" && (
                    <button
                      onClick={() => { window.scrollTo(0, 0); navigate('/consultant/dashboard'); }}
                      className="flex-1 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm whitespace-nowrap flex items-center justify-center gap-2"
                    >
                      <User className="w-4 h-4" />
                      Hello Engineer {user.name?.split(" ")[0] || "Consultant"}
                    </button>
                  )}
                  {/* Always show login buttons for other roles */}
                  {userType !== "builder" && (
                    <button
                      onClick={() => { window.scrollTo(0, 0); navigate('/login?type=builder'); }}
                      className="flex-1 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm whitespace-nowrap"
                    >
                      Builder Login
                    </button>
                  )}
                  {userType !== "agent" && (
                    <button
                      onClick={() => { window.scrollTo(0, 0); navigate('/agent/login'); }}
                      className="flex-1 px-4 py-2 border-2 border-gray-300 hover:border-amber-500 text-white hover:text-amber-400 font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm bg-transparent whitespace-nowrap"
                    >
                      Agent Login
                    </button>
                  )}
                </div>
              )}
              {(!token || !user) && (
                <>
                  <button
                    onClick={() => navigate('/login?type=builder')}
                    className="flex-1 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm whitespace-nowrap"
                  >
                    Builder Login
                  </button>
                  <button
                    onClick={() => navigate('/agent/login')}
                    className="flex-1 px-4 py-2 border-2 border-gray-300 hover:border-amber-500 text-white hover:text-amber-400 font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75 text-sm bg-transparent whitespace-nowrap"
                  >
                    Agent Login
                  </button>
                </>
              )}
              {/* <button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate('/job-portal');
                }}
                className="flex-1 px-3 py-1.5 border-2 border-gray-300 hover:border-blue-500 text-white hover:text-blue-400 font-semibold rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 text-sm bg-transparent"
              >
                Job Portal
              </button> */}
            </div>
          </div>

          {/* Main Footer Content with increased margin */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:flex gap-x-4 gap-y-4 mb-3">
            {/* Column 1: Logo, Description */}
            <div className="lg:w-1/4 lg:mr-6 mb-4 lg:mb-0 flex-shrink-0">
              <img
                src="/assets/Transparent background.png"
                alt="Ducktail Logo"
                className="h-10 sm:h-12 mb-2"
              />
              <p className="text-xs leading-relaxed max-w-xs text-gray-300">
                Ducktail simplifies construction by connecting you with verified, qualified builders, ensuring quality and reliability for your projects.
              </p>
            </div>

            {/* Column 2: Explore */}
            <div className="lg:w-1/4">
              <h5 className="text-sm font-semibold text-white mb-2">Explore</h5>
              <ul className="space-y-1 text-xs">
                <li><a href="/" className="hover:text-white transition-colors">Home</a></li>
                <li><a href="/#services" className="hover:text-white transition-colors">Our Services</a></li>
                <li><a href="/support" className="hover:text-white transition-colors">Support Center</a></li>
                <li><a href="/#testimonials" className="hover:text-white transition-colors">Testimonials</a></li>
                <li><a href="/builderslist" className="hover:text-white transition-colors">Find Builders</a></li>
              </ul>
            </div>

            {/* Column 3: Get in Touch */}
            <div className="lg:w-1/4">
              <h5 className="text-sm font-semibold text-white mb-2">Get in Touch</h5>
              <address className="not-italic space-y-1 text-xs">
                <div className="flex items-start space-x-2">
                  <MapPinIcon className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                  <span>Tamil Nadu, India</span>
                </div>
                <div className="flex items-start space-x-2">
                  <Mail className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                  <a href="mailto:connect@ducktail.in" className="hover:text-white transition-colors ">connect@ducktail.in</a>
                </div>
              </address>
            </div>

            {/* Column 4: Reach Us */}
            <div className="lg:w-1/4">
              <h5 className="text-sm font-semibold text-white mb-2">Reach Us</h5>
              <div className="flex space-x-4 mt-1">
                <a href="https://www.facebook.com/DucktailConstructionPlatform" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-amber-400 transition-colors duration-150">
                  <Facebook size={18} />
                </a>
                <a href="https://www.instagram.com/ducktail_official/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-pink-500 transition-colors duration-150">
                  <Instagram size={18} />
                </a>
                <a href="https://www.linkedin.com/company/ducktailconstruction/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-amber-400 transition-colors duration-150">
                  <Linkedin size={18} />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar: Copyright and Policy Links with reduced margin/padding */}
          <div className="mt-3 pt-2 border-t border-gray-700 text-center md:text-left">
            <div className="flex flex-col md:flex-row justify-between items-center text-xs">
              <p className="mb-1 md:mb-0 text-gray-300">© {new Date().getFullYear()} DUCKTAIL PRIVATE LIMITED. All Rights Reserved.</p>
              <div className="flex space-x-3 sm:space-x-4">
                <a href="/termscondition" className="hover:text-white transition-colors">Terms & Conditions</a>
                <a href="/privacypolicy" className="hover:text-white transition-colors">Privacy Policy</a>
                <a href="/refundpolicy" className="hover:text-white transition-colors">Refund Policy</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footerlanding;